import React from "react";

function Title({ title, paragraph, className, children }) {
  return (
    <div className={`${className} section-title`} style={{ maxWidth: "760px", margin: '0 10px' }}>
      <h2 style={{ color: 'rgb(84 84 84)' }} className="d-flex  fw-semibold  mb-2 text-center">{title}
        {children}
      </h2>

      <div className="mx-auto " style={{ width: '80%', marginBottom: '2px', height: '5px', background: 'rgba(242, 110, 99,0.7)', clipPath: 'polygon(0 0, 100% 0, 99% 100%, 1% 100%)' }}>

      </div>
      <div className="mx-auto mb-4" style={{ width: '78%', height: '5px', background: 'rgba(242, 110, 99,0.4)', clipPath: 'polygon(0 0, 100% 0, 99% 100%, 1% 100%)' }}>

      </div>


      {paragraph && <p className="lead text-center" style={{ color: "var(--grey)" }}>
        {paragraph}
      </p>}
    </div>
  );
}

export default Title;
